import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { storage } from '@uhg-abyss/web/tools/storage';
import add from 'date-fns/add';
import isAfter from 'date-fns/isAfter';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import { RESET_TIME } from '../constants';

export const IdleTimer = ({
  events,
  eventTimeout,
  idleTimeout,
  onIdle,
  modalOpen,
  children,
}) => {
  let idleTimer;
  let eventTimer;

  const resetTimer = (event, timeDiff) => {
    if (!eventTimer || timeDiff) {
      if (!timeDiff) {
        const newTime = add(new Date(), { seconds: idleTimeout / 1000 });
        storage.local.set(RESET_TIME, newTime);
      }

      clearTimeout(idleTimer);
      const timeoutTime = idleTimeout;
      idleTimer = setTimeout(() => {
        idleTimer = null;
        // eslint-disable-next-line no-use-before-define
        onTimerIdle();
      }, timeDiff || timeoutTime);

      clearTimeout(eventTimer);
      eventTimer = setTimeout(() => {
        eventTimer = null;
      }, eventTimeout);
    }
  };

  const addListeners = () => {
    events.forEach((e) => document.addEventListener(e, resetTimer));
  };

  const removeListeners = () => {
    events.forEach((e) => document.removeEventListener(e, resetTimer));
    clearTimeout(idleTimer);
    clearTimeout(eventTimer);
  };

  const onTimerIdle = () => {
    const storedTime = new Date(storage.local.get(RESET_TIME));
    const now = new Date();

    if (isAfter(storedTime, now)) {
      const timeDiff = differenceInMilliseconds(storedTime, now);
      resetTimer(null, timeDiff);
    } else {
      idleTimer = null;
      removeListeners();
      onIdle();
    }
  };

  useEffect(() => {
    addListeners();
    resetTimer();

    return () => {
      removeListeners();
    };
  }, []);

  useEffect(() => {
    if (!modalOpen) {
      addListeners();
      resetTimer();
    }
  }, [modalOpen]);

  return children;
};

IdleTimer.propTypes = {
  children: PropTypes.node,
  eventTimeout: PropTypes.number,
  idleTimeout: PropTypes.number,
  events: PropTypes.arrayOf(PropTypes.string),
  onIdle: PropTypes.func,
};

IdleTimer.defaultProps = {
  children: null,
  eventTimeout: 10000,
  idleTimeout: 1200000,
  events: [
    'mousemove',
    'keydown',
    'wheel',
    'DOMMouseScroll',
    'mousewheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'scroll',
    'MSPointerDown',
    'MSPointerMove',
  ],
  onIdle: () => null,
};
